'use client'
import { ModalHeader, ModalTitle } from '@repo/ui/components'
import { useState } from 'react'
import { ChangeMobileKycForm } from './change-mobile-kyc.form'
import { ChangeMobileKycOtp } from './change-mobile-kyc.otp'
import { useTranslate } from '@repo/shared/hooks'

export const ChangeMobileKycContainer = ({
  hasValue,
}: {
  hasValue: boolean
}) => {
  const { t } = useTranslate()
  const [changeStep, setChangeStep] = useState<'otp' | 'form'>('form')
  const [mobile, setMobile] = useState<string>('')
  const [otp, setOtp] = useState<number>(0)
  const handleFormSuccess = (mobileValue: string, otp: number) => {
    setMobile(mobileValue)
    setOtp(otp)
    setChangeStep('otp')
  }

  return (
    <>
      {changeStep === 'otp' && (
        <>
          <ModalHeader>
            <ModalTitle>{t('changeMobileKyc_confirm_title')}</ModalTitle>
          </ModalHeader>
          <ChangeMobileKycOtp
            otp={otp}
            mobile={mobile}
            handleBack={() => setChangeStep('form')}
          />
        </>
      )}
      {changeStep === 'form' && (
        <>
          <ModalHeader>
            <ModalTitle>
              {!hasValue
                ? t('changeMobileKyc_title_register')
                : t('changeMobileKyc_title_change')}
            </ModalTitle>
          </ModalHeader>
          <ChangeMobileKycForm mobile={mobile} onSuccess={handleFormSuccess} />
        </>
      )}
    </>
  )
}
